import React, { useEffect, useState } from "react";
import TableHead from "@/components/tables/TableHead";
import ReportedUsersTable from "@/components/tables/ReportedUsersTable";
import { useDataQueries } from "@/utils/hooks/useDataQueries";
import { errorToasterMessage } from "@/utils/functions/toaster";
import { fetchUsers } from "@/services/user.service";
import { getListCacheBootstrap, writeListCache } from "@/utils/listPageCache";

const ReportedUsers = () => {
    const [pageNo, setPageNo, dataLength, setDataLength, sorting, setSorting, filter, setFilter, searchItem, setSearchItem, resetDataQueries] = useDataQueries();
    const reportedFilter = { is_reported: true };
    const listBootstrap = getListCacheBootstrap("reported-users", { dataLength, sorting, searchItem, filter: reportedFilter });

    const [isLoading, setIsLoading] = useState(!listBootstrap.hasCache);
    const [reportedUsers, setReportedUsers] = useState<any>(listBootstrap.items);
    const [usersLeft, setUsersLeft] = useState(true);
    const [allFetched, setAllFetched] = useState(false);
    const [dataLoad, setDataLoad] = useState(!listBootstrap.hasCache);
    const [totalCount, setTotalCount] = useState(listBootstrap.totalCount);

    useEffect(() => {
        const { cacheKey, cached } = getListCacheBootstrap("reported-users", {
            dataLength,
            sorting,
            searchItem,
            filter: reportedFilter,
        });

        setPageNo(1);
        setUsersLeft(true);
        setAllFetched(false);
        if (cached) {
            setReportedUsers(cached.items);
            setTotalCount(cached.totalCount);
            setDataLoad(false);
            setIsLoading(false);
        } else {
            setIsLoading(true);
            setDataLoad(true);
        }

        fetchUsers(
            1,
            dataLength,
            sorting,
            reportedFilter,
            searchItem,
            (response: any) => {
                const nextUsers = response.data.users ?? [];
                writeListCache(cacheKey, nextUsers, response.data.total_count);
                setIsLoading(false);
                setDataLoad(false);
                setTotalCount(response.data.total_count);
                setReportedUsers(nextUsers);
                setUsersLeft(false);
                setAllFetched(true);
            },
            (error: any) => {
                setIsLoading(false);
                setDataLoad(false);
                errorToasterMessage(error);
            }
        );
    }, [dataLength, sorting, searchItem]);

    const handleSuspendUser = (userId: string) => {
            const updatedUsers = reportedUsers.map((user: any) => {
                if (user.id === userId) {
                    return { ...user, status: 'suspended' };
                }
                return user;
            });
            setReportedUsers(updatedUsers);
    };



    const resetResponse = () => {
        setUsersLeft(true);
        setAllFetched(false);
    };

    const reset = () => {
        resetDataQueries?.();
        resetResponse();
    };

    const search = (searchText: string) => {
        setSearchItem(searchText);
    };

    return (
        <div className="gs-list-page-card">
            <div className="gs-list-page-card-header">
                <TableHead
                    id='reported-users-table'
                    handleReset={resetResponse}
                    pageNo={pageNo}
                    dataLength={dataLength}
                    setFilter={setFilter}
                    filter={filter}
                    setDataLength={setDataLength}
                    reset={reset}
                    search={search}
                    title="Reported Users"
                    options={[]}
                    handleApplyFilter={() => {}}
                    setPageNo={setPageNo}
                    currentEnvo={reportedUsers.length}
                    totalEnvo={totalCount}
                />
            </div>
            <div>
                <ReportedUsersTable
                    id='reported-users-table'
                    reset={reset}
                    setUsers={setReportedUsers}
                    search={search}
                    isLoading={isLoading}
                    dataLength={dataLength}
                    sorting={sorting}
                    setSorting={setSorting}
                    title="Reported Users"
                    searchItem={searchItem}
                    allFetched={allFetched}
                    users={reportedUsers}
                    setPageNo={setPageNo}
                    dataload={dataLoad}
                    resetDataQueries={resetDataQueries}
                    onSuspendUser={handleSuspendUser}
                />
            </div>
        </div>
    );
};

export default ReportedUsers;